import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import style from './CandleMagnitudeTacticPanel.module.css';
import {
  CandleMagnitudeStopHeader,
  CandleMagnitudeTargetHeader,
} from './CandleMagnitudeHeaders';
import {
  CandleMagnitudeStopRows,
  CandleMagnitudeTargetRows,
} from './CandleMagnitudeRows';

export const CandleMagnitudeTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
    const softOrderId = tradePlan?.exitTactics['CANDLE_MAGNITUDE']?.tacticId ?? null;
    const inPosition = tradePlan?.inPosition;
    const direction = tradePlan?.goShort ? 'short' : 'long';
    
    if (!tradePlan?.exitTactics['CANDLE_MAGNITUDE']) return null;
    return (
      <TabPanel {...rest}>
        {inPosition && softOrderId ? (
          <div>
            <div className={style.tableContainer}>
              <table className={style.table}>
                <CandleMagnitudeTargetHeader />
                <CandleMagnitudeTargetRows
                  tradePlanId={tradePlanId}
                  softOrderId={softOrderId}
                  direction={direction}
                />
              </table>
              <table className={style.table}>
                <CandleMagnitudeStopHeader />
                <CandleMagnitudeStopRows
                  tradePlanId={tradePlanId}
                  softOrderId={softOrderId}
                  direction={direction}
                />
              </table>
            </div>
            <Body3 fontWeight={700} color={colors.red} margin="0 0 0 auto">
              * A red highlighted row indicates an automatic stop.
            </Body3>
          </div>
        ) : (
          <Body3 fontWeight={700} color={colors.lightGrey}>
            This tactic is not editable until trade enters.
          </Body3>
        )}
      </TabPanel>
    );
  }
);

CandleMagnitudeTacticPanel.tabsRole = 'TabPanel';
